module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-item"
  }, [(_vm.rates.length) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.rates), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "label rate"
    }, [_vm._v(_vm._s(item.attrName) + ":")]), _vm._v(" "), _c('el-rate', {
      attrs: {
        "value": _vm._f("toNumber")(item.value4Show),
        "colors": _vm._f("toColor")(item.value4Show),
        "disabled": ""
      }
    }), _vm._v(" "), (item.value4Show < 3) ? _c('span', {
      staticClass: "tag low"
    }, [_vm._v("低")]) : (item.value4Show > 4) ? _c('span', {
      staticClass: "tag high"
    }, [_vm._v("高")]) : _c('span', {
      staticClass: "tag mid"
    }, [_vm._v("中")])], 1)
  }))])]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("基本资料")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.detailData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.attrName) + ":")]), _vm._v(" "), ([5, 6, 7, 8, 10, 0].indexOf(item.fieldType) === -1 && !item.popType) ? [(['contractCost', 'cost', 'grossProfit', 'grossProfitRate', 'cashProfit', 'cashProfitRate'].indexOf(item.attr) > -1) ? [_c('span', {
      class: {
        'costRed': (item.attr === 'grossProfitRate' || item.attr === 'cashProfitRate') && _vm.judgeNegative(item.value4Show), 'text': true
      }
    }, [_vm._v(_vm._s(item.value4Show || '--'))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": _vm.tooltipObj[item.attr][_vm.moduleName] || _vm.tooltipObj[item.attr],
        "placement": "top",
        "effect": "light"
      }
    }, [_c('span', {
      staticClass: "icon el-icon-question"
    })])] : [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.value4Show || '--'))])]] : ([5, 6].indexOf(item.fieldType) > -1) ? [_c('div', {
      staticClass: "img-box"
    }, _vm._l((_vm.strToArr(item.value4Show)), function(url, index) {
      return _c('span', {
        key: index,
        staticClass: "img",
        on: {
          "click": function($event) {
            _vm.openLightbox(url)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": url,
          "height": "40",
          "width": "40"
        }
      })])
    }))] : (item.fieldType === 8) ? [(item.value4Show) ? _c('attachment-preview', {
      attrs: {
        "data": item.value4Show
      }
    }) : _vm._e()] : (item.fieldType === 7) ? [_c('div', {
      staticClass: "text"
    }, _vm._l((_vm.paragraph(item.value4Show)), function(p, index) {
      return _c('p', {
        key: index
      }, [_vm._v(_vm._s(p))])
    }))] : (item.popType === 1) ? [(!item.multiValue) ? _c('span', {
      staticClass: "text"
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDetail(item.popModel, item.id, item.isRed)
        }
      }
    }, [_vm._v(_vm._s(item.value4Show))])]) : _c('span', _vm._l((item.multiValue), function(n, index) {
      return _c('span', [_c('a', {
        staticClass: "text",
        on: {
          "click": function($event) {
            _vm.openDetail(n.popModel, n.id, item.isRed)
          }
        }
      }, [_vm._v(_vm._s(n.value4Show))]), _vm._v(" "), (index !== item.multiValue.length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
    }))] : (item.fieldType === 10) ? [_c('span', {
      staticClass: "text"
    }, [_c('el-rate', {
      attrs: {
        "value": _vm._f("toNumber")(item.value4Show),
        "disabled": ""
      }
    })], 1)] : (item.attr === 'phone') ? [_c('div', {
      staticClass: "phone-arr"
    }, _vm._l((_vm.strsplit(item.value4Show)), function(p, index) {
      return _c('p', {
        key: index,
        staticClass: "text"
      }, [_vm._v(_vm._s(p))])
    }))] : [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.value4Show || '--'))])]], 2)
  }))]), _vm._v(" "), (_vm.origin && JSON.stringify(_vm.origin) !== '{}') ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("原回款信息")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("回款编号:")]), _vm._v(" "), _c('a', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.openDetail(_vm.origin.paymentNo.popModel, _vm.origin.paymentNo.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.origin.paymentNo.paymentNo || '--'))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("计划回款金额:")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.amount))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("实收金额:")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.realAmount))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("未收金额")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.unAmount))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("回款状态:")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.status || '--'))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("回款类型:")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.paymentType || '--'))])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("负责人:")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.userName || '--'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.otherDetail) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("其他信息")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.otherDetail), function(value, key) {
    return _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(key) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(value))])])
  }))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aef9a8b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/basic-item.vue
// module id = 1325
// module chunks = 82